/**
 * The main component that renders single TabComponent
 * instances.
 */

import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';

import { LoaderService } from '../loader/loader.service';

import { TabComponent } from './tab.component';

@Component({
	selector: 'my-tabs',
	template: `
		<ul class="nav nav-tabs noprint">
			<li *ngFor="let tab of tabs; let i = index" (click)="selectTab(tab, i)" [class.active]="tab.active">
				<a>{{ tab.title }}</a>
			</li>
		</ul>
		<ng-content></ng-content>
	`,
})
export class TabsComponent implements AfterContentInit {
	constructor(private LoaderService: LoaderService) {}

	@ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

	// contentChildren are set
	ngAfterContentInit() {
		// get all active tabs
		//let activeTab = this.tabs.filter((tab) => tab.active);
		let ls = localStorage.getItem('activeTab');
		let activeTab = this.tabs.filter((tabs) => tabs.title == ls);

		if (!(this.tabs.first.title == 'Admin Charts' && ls != 'Admin' && ls != 'Edit Questions and Phases')) {
			/* Hack fix: If in Subtab (starts with 'Admin Charts')
				AND we didn't just click Admin or just move from Edit Questions & Phases,
				DON'T bother loading.
				This solves sub-tab forcing focus on first load or on Back from Student page.
			*/

			// if there is no active tab set, activate the first
			if (activeTab.length === 0) {
				this.selectTab(this.tabs.first);
			} else {
				this.selectTab(activeTab[0]);
			}
		}
	}

	getTab(tabTitle: string) {
		return this.tabs.find((tab) => tab.title === tabTitle) || null;
	}

	selectTab(tab: any) {
		setTimeout(() => {
			window.dispatchEvent(new Event('resize'));
		}, 0);
		// deactivate all tabs
		this.tabs.toArray().forEach((tab) => (tab.active = false));
		//this.LoaderService.setLoadingGrowthChart(true);

		// activate the tab the user has clicked on.
		tab.active = true;
		localStorage.setItem('activeTab', tab.title);
		console.log(tab);
	}
}
